import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M5 4v3h5.5v12h3V7H19V4z" />, 'Title');
